/**
 * Session endpoints — POST /session/{id}/profile + /reset.
 * NO requieren X-Device-Token (analytics post-hoc, device_id Pydantic + presence).
 */
import type { ProfileType } from '../types/profile'

export async function setProfile(sessionId: string, profile: ProfileType): Promise<void> {
  const res = await fetch(`/api/session/${sessionId}/profile`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ profile }),
  })
  if (!res.ok) throw new Error(`setProfile failed ${res.status}`)
}

export async function resetSession(sessionId: string): Promise<void> {
  const res = await fetch(`/api/session/${sessionId}/reset`, { method: 'POST' })
  if (!res.ok) throw new Error(`reset failed ${res.status}`)
}
